import React from "react";
import SuccessIcon from "../../assets/icons/success.svg";
import BaseButton from "../base/BaseButton";
import { Link } from "react-router-dom";

const ResetSuccessful = () => {
  return (
    <div>
      <div className="flex flex-col items-center justify-center lg:py-8 py-4 w-full ">
        <div className="flex justify-center">
          <img src={SuccessIcon} alt="successIcon" width={100} />
        </div>
        <div className="py-6 text-center">
          <p className="text-center lg:text-[32px] text-lg text-[#4F4F4F] pb-2 font-bold">
            All Done!
          </p>
          <span className="text-center text-[#4F4F4F] text-[16px]">
            Your Password has been reset.
          </span>
        </div>
        <BaseButton
          text="Log into your Account"
          variant="primary"
          styles=" w-64 mt-4 px-6"
          to={"/login"}
        />

        <Link
          to={"/login"}
          className="mt-10 flex  primary_text_color justify-center text-center"
        >
          Return to homepage
        </Link>
      </div>
    </div>
  );
};

export default ResetSuccessful;
